function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _this = this,
  _arguments = typeof arguments === "undefined" ? void 0 : arguments;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import DOMPurify from "dompurify";

// Polyfills
if (!("remove" in Element.prototype)) {
  Element.prototype.remove = function () {
    if (this.parentNode) {
      this.parentNode.removeChild(this);
    }
  };
}
if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}
if (!Element.prototype.closest) {
  Element.prototype.closest = function (s) {
    var el = _this;
    do {
      if (el.matches(s)) return el;
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
  };
}
var checkTouch = function checkTouch() {
  var $html = $("html");
  if ("ontouchstart" in document.documentElement) {
    $html.removeClass("no-touchevents");
    $html.addClass("touchevents");
  }
  if ($html.hasClass("no-touchevents")) {
    $(window).on("touchstart.touchTest", function () {
      $html.removeClass("no-touchevents");
      $html.addClass("touchevents");
      $(window).off("touchstart.touchTest");
    });
  }
};
var isMobile = function isMobile() {
  var result = false;
  (function (a) {
    result = /Android|webOS|iPhone|iPad|BlackBerry|Windows Phone|Opera Mini|IEMobile|Mobile/i.test(a);
  })(navigator.userAgent || navigator.vendor || window.opera);
  return result;
};
var isInView = function isInView(el, view) {
  var rect = el.getBoundingClientRect();
  var html = document.documentElement;
  if (view === "completely") {
    // to check if completely visible
    return rect.top >= 0 && rect.bottom <= (window.innerHeight || html.clientHeight);
  }
  if (view === "partially") {
    // to check if partially visible
    return rect.bottom >= 0 && rect.top < (window.innerHeight || html.clientHeight);
  }

  // if partially visible or above current fold,
  return rect.top < (window.innerHeight || html.clientHeight);
};
var getScript = function getScript(source, callback) {
  var prior = document.getElementsByTagName("script")[0];
  var script = document.createElement("script");
  script.async = 1;

  // eslint-disable-next-line no-multi-assign
  script.onload = script.onreadystatechange = function (_, isAbort) {
    if (isAbort || !script.readyState || /loaded|complete/.test(script.readyState)) {
      // eslint-disable-next-line no-multi-assign
      script.onload = script.onreadystatechange = null;
      script = undefined;
      if (!isAbort) {
        if (callback) {
          callback();
        }
      }
    }
  };
  script.src = source;
  prior.parentNode.insertBefore(script, prior);
};
var setCookie = function setCookie(cookieName) {
  var cookieValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var cookieDuration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 365;
  var sameSite = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var d = new Date();
  d.setTime(d.getTime() + cookieDuration * 24 * 60 * 60 * 1000);
  var expires = 'expires=' + d.toUTCString();
  var cookieString = '';
  var value = typeof cookieValue !== "string" ? JSON.stringify(cookieValue) : cookieValue;
  cookieString = "".concat(cookieName, "=").concat(value, "; ").concat(expires, "; path=/");
  if (sameSite) {
    cookieString = "".concat(cookieString, "; ").concat(sameSite);
  }
  document.cookie = cookieString;
};
var getCookie = function getCookie(cookieName) {
  var parseJSON = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var cookieValue = null;
  document.cookie.split(";").forEach(function (cookie) {
    if (cookie.indexOf(cookieName) !== -1) {
      cookieValue = cookie.trim().split("=").slice(-1)[0].trim();
    }
  });
  if (parseJSON) {
    return JSON.parse(decodeURIComponent(cookieValue));
  }
  return cookieValue;
};
var getCookiePath = function getCookiePath() {
  return window.location.protocol.indexOf('https:') !== -1 ? "SameSite=None; Secure" : "";
};
var deleteCookie = function deleteCookie(cookieName) {
  document.cookie = "".concat(cookieName, "=; expires=Thu, 01 Jan 1970 00:00:01 GMT;");
};
var getQuery = function getQuery() {
  return window.location.search ? window.location.search.slice(1).split('&').map(function (query) {
    return query.split('=').map(function (p) {
      return window.decodeURIComponent(p).trim();
    });
  }).reduce(function (acc, p) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, p[0], p[1]));
  }, {}) : {};
};
var documentWidth = function documentWidth() {
  var e = window;
  var a = "inner";
  if (!("innerWidth" in window)) {
    a = "client";
    e = document.documentElement || document.body;
  }
  return {
    width: e["".concat(a, "Width")],
    height: e["".concat(a, "Height")]
  };
};
var debounce = function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = _this,
      args = _arguments;
    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};
DOMPurify.addHook("afterSanitizeAttributes", function (node) {
  // set all elements owning target to target=_blank
  if ("target" in node) {
    node.setAttribute("target", "_blank");
    // prevent https://www.owasp.org/index.php/Reverse_Tabnabbing
    node.setAttribute("rel", "noopener noreferrer");
  }
});
var purifier = function purifier(text, config) {
  return DOMPurify.sanitize(text, config);
};
export { checkTouch, isMobile, isInView, getScript, setCookie, getCookie, getCookiePath, deleteCookie, getQuery, documentWidth, debounce, purifier };


// WEBPACK FOOTER //
// ./scripts/util/dom.js